/*
 * js-cart.js — סל הקניות ומגירת הסל של מרכז החשמל והמחשבים.
 *
 * למה הקובץ הזה קיים בכלל:
 *
 * 1. js-nuranium.js בונה את גוף המגירה כמחרוזות HTML בדפדפן, עם טקסט
 *    אנגלי קשיח ("There are N items in your cart") ועם סרגל התקדמות
 *    ל"משלוח חינם". החנות הזו היא איסוף באילת בלבד. כאן אנחנו מושכים
 *    את אותו גוף מגירה מהשרת (/cart?view=json) ודורסים את מה שנבנה
 *    בדפדפן, כך שיש מקור אמת אחד — Liquid.
 *
 * 2. אותו קובץ מחשב בדפדפן סכום שורה (מחיר × כמות) ודורס את תווית
 *    המע״מ שמתחת לסכום הכולל. חשבון על מחיר בדפדפן אסור בפרויקט הזה.
 *    כאן כל סכום מגיע מרינדור מחדש של הסקשן בשרת, דרך
 *    Section Rendering API, ועובר תמיד דרך פילטר money.
 *
 * 3. מגירת הסל נפתחת בלי ניהול פוקוס, בלי Escape ובלי שם נגיש לכפתור
 *    הסגירה. ת"י 5568 AA היא דרישה חוקית לחנות הזו.
 *
 * הקובץ מיירט את האירועים בשלב ה-capture על document, לפני שהם מגיעים
 * למאזינים המוקצים של jQuery, ועוצר את ההתפשטות — כך אין צורך לגעת
 * ב-js-nuranium.js עצמו.
 */
(function () {
  'use strict';

  if (window.jmCartLoaded) return;
  window.jmCartLoaded = true;

  var SELECTORS = {
    section: '[data-jm-cart-section]',
    form: '[data-jm-cart-form]',
    status: '[data-jm-cart-status]',
    total: '[data-jm-cart-total]',
    drawer: '#desktop_cart',
    drawerBody: '#cart-info',
    drawerClose: '.close_cart',
    popupBody: '#content_cart__popup_nt',
    popupDialog: '.cart__popup_upsell'
  };

  var strings = {};
  var busy = false;
  var pendingChanges = [];
  var batchFailed = false;
  var pendingFocus = null;

  function readStrings() {
    var el = document.querySelector('[data-jm-cart-strings]');
    if (!el) return;
    try {
      strings = JSON.parse(el.textContent) || {};
    } catch (e) {
      strings = {};
    }
  }

  function rootPath() {
    var root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    return root === '/' ? '' : root.replace(/\/$/, '');
  }

  function announce(message, failed) {
    if (!message) return;
    [SELECTORS.drawerBody, SELECTORS.popupBody].forEach(function (selector) {
      var surface = document.querySelector(selector);
      if (!surface || surface.querySelector(SELECTORS.status)) return;
      var status = document.createElement('p');
      status.setAttribute('data-jm-cart-status', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      surface.appendChild(status);
    });
    document.querySelectorAll(SELECTORS.status).forEach(function (el) {
      el.classList.toggle('visually-hidden', !failed);
      el.textContent = message;
    });
  }

  function closest(node, selector) {
    while (node && node.nodeType === 1) {
      if (node.matches(selector)) return node;
      node = node.parentElement;
    }
    return null;
  }

  /* ---------------------------------------------------------------- *
   * רינדור מחדש מהשרת
   * ---------------------------------------------------------------- */

  function fetchText(url) {
    return fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (res) {
      if (!res.ok) throw new Error(res.status);
      return res.text();
    });
  }

  /* ---------------------------------------------------------------- *
   * שדה הקופון: ערך, מצב פתוח, פוקוס וסמן
   *
   * שני המשטחים מחליפים ‎innerHTML‎ שלם אחרי כל שינוי כמות. קוד שהלקוח
   * הקליד ועדיין לא שלח שייך ללקוח, לא לרינדור — ולכן הוא נשמר ומוחזר,
   * ואיתו גם מצב הפתיחה, הפוקוס ומיקום הסמן. בלי מיקום הסמן הטקסט אמנם
   * שורד אבל האצבע קופצת לסוף המחרוזת באמצע הקלדה.
   *
   * זה מה שאיפשר להוציא את הקופון מהלוח הנפתח אל תוך השורה עצמה: הסיבה
   * היחידה שהוא ישב מחוץ ל-‎#cart-info‎ הייתה שהוא לא שרד את הרינדור.
   * ---------------------------------------------------------------- */

  function captureCoupon(root) {
    if (!root) return null;
    var input = root.querySelector('[data-jm-cart-keep]');
    var details = root.querySelector('[data-jm-coupon]');
    var focused = !!input && document.activeElement === input;
    var snap = {
      value: input ? input.value : null,
      open: details ? details.hasAttribute('open') : false,
      focused: focused,
      start: null,
      end: null
    };
    if (focused) {
      try {
        snap.start = input.selectionStart;
        snap.end = input.selectionEnd;
      } catch (error) {
        snap.start = null;
      }
    }
    return snap;
  }

  function restoreCoupon(root, snap) {
    if (!root || !snap) return;
    var input = root.querySelector('[data-jm-cart-keep]');
    var details = root.querySelector('[data-jm-coupon]');
    if (input && snap.value !== null) input.value = snap.value;
    if (details && (snap.open || snap.value)) details.setAttribute('open', '');
    if (!input || !snap.focused) return;
    try {
      input.focus({ preventScroll: true });
    } catch (error) {
      input.focus();
    }
    if (snap.start === null) return;
    try {
      input.setSelectionRange(snap.start, snap.end);
    } catch (error) {
      /* קלט שלא תומך בטווח בחירה — הערך עצמו כבר הוחזר */
    }
  }

  function refreshDrawer() {
    var body = document.querySelector(SELECTORS.drawerBody);
    if (!body) return Promise.resolve();
    return fetchText(rootPath() + '/cart?view=json')
      .then(function (html) {
        var coupon = captureCoupon(body);
        body.innerHTML = html;
        restoreRenderedQuantities(body);
        restoreCoupon(body, coupon);
        var drawer = document.querySelector(SELECTORS.drawer);
        if (drawer) drawer.classList.toggle('item_count', html.indexOf('ajaxcart__footer') !== -1);
      });
  }

  function refreshSection() {
    var section = document.querySelector(SELECTORS.section);
    if (!section) return Promise.resolve();
    var id = section.getAttribute('data-section-id');
    if (!id) return Promise.resolve();
    return fetchText(rootPath() + '/cart?section_id=' + encodeURIComponent(id))
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector(SELECTORS.section);
        if (!fresh) throw new Error('Missing cart section');
        var note = section.querySelector('[name="note"]');
        var noteValue = note ? note.value : null;
        /* שדה הקופון — ראו captureCoupon/restoreCoupon. */
        var coupon = captureCoupon(section);
        section.innerHTML = fresh.innerHTML;
        restoreRenderedQuantities(section);
        var freshNote = section.querySelector('[name="note"]');
        if (freshNote && noteValue !== null) freshNote.value = noteValue;
        restoreCoupon(section, coupon);
      });
  }

  function refreshPopup() {
    var popup = document.querySelector(SELECTORS.popupBody);
    if (!popup) return Promise.resolve();
    return fetchText(rootPath() + '/cart?view=upsell')
      .then(function (html) {
        popup.innerHTML = html;
        restoreRenderedQuantities(popup);
      });
  }

  function syncHeaderCountLabel(itemCount) {
    var countLabel = document.querySelector('[data-jm-cart-count-label]');
    if (countLabel) {
      var singular = countLabel.getAttribute('data-singular') || 'פריט';
      var plural = countLabel.getAttribute('data-plural') || 'פריטים';
      countLabel.textContent = itemCount === 1 ? singular : plural;
    }
  }

  function syncHeader(itemCount) {
    var counts = document.querySelectorAll('.CartCount, #CartCountCavas');
    var i;
    for (i = 0; i < counts.length; i += 1) counts[i].textContent = itemCount;
    syncHeaderCountLabel(itemCount);

    var headerTotal = document.getElementById('header-cart-total');
    if (!headerTotal) return;
    var total = document.querySelector(SELECTORS.total);
    if (total) headerTotal.textContent = total.textContent.trim();
  }

  function setupHeaderCountLabel() {
    var count = document.getElementById('CartCountCavas');
    if (!count) return;

    function syncFromCount() {
      var itemCount = parseInt(count.textContent, 10);
      if (!isNaN(itemCount)) syncHeaderCountLabel(itemCount);
    }

    new MutationObserver(syncFromCount).observe(count, {
      childList: true,
      subtree: true,
      characterData: true
    });
    syncFromCount();
  }

  function refreshAll(itemCount) {
    return Promise.allSettled([refreshSection(), refreshDrawer(), refreshPopup()]).then(function (results) {
      if (results.some(function (result) { return result.status === 'rejected'; })) throw new Error('Cart refresh failed');
      syncHeader(itemCount);
    });
  }

  /* ---------------------------------------------------------------- *
   * שינוי כמות והסרה — בלי ריענון עמוד, בלי חשבון על מחיר
   * ---------------------------------------------------------------- */

  function queueKey(payload) {
    return payload.id ? 'id:' + payload.id : 'line:' + payload.line;
  }

  function changeLine(payload, focusMarker) {
    var key = queueKey(payload);
    var existing = pendingChanges.findIndex(function (change) { return queueKey(change) === key; });
    if (existing === -1) pendingChanges.push(payload);
    else pendingChanges[existing] = payload;
    if (focusMarker) pendingFocus = focusMarker;
    announce(strings.updating || '');
    runChanges();
  }

  function runChanges() {
    if (busy || !pendingChanges.length) return;
    busy = true;
    var payload = pendingChanges.shift();
    fetch(rootPath() + '/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .catch(function () {
        batchFailed = true;
        return fetch(rootPath() + '/cart.js', { credentials: 'same-origin' }).then(function (res) {
          if (!res.ok) throw new Error(res.status);
          return res.json();
        });
      })
      .then(function (cart) {
        if (pendingChanges.length) return;
        var focusMarker = pendingFocus;
        pendingFocus = null;
        return refreshAll(cart.item_count).then(function () {
          restoreCartFocus(focusMarker);
        });
      })
      .catch(function () {
        batchFailed = true;
      })
      .then(function () {
        busy = false;
        if (pendingChanges.length) {
          // A refresh may have replaced an input while its next change waited.
          pendingChanges.forEach(function (change) {
            document.querySelectorAll(QTY_INPUTS).forEach(function (input) {
              if (queueKey(payloadFor(input, 0)) === queueKey(change)) input.value = change.quantity;
            });
          });
          runChanges();
        } else {
          announce(batchFailed ? strings.update_failed || '' : strings.updated || '', batchFailed);
          batchFailed = false;
        }
      });
  }

  function payloadFor(input, quantity) {
    var key = input.getAttribute('data-key') || input.getAttribute('data-id');
    var line = input.getAttribute('data-line');
    if (key) return { id: key, quantity: quantity };
    return { line: parseInt(line, 10), quantity: quantity };
  }

  function clamp(input, quantity) {
    var max = parseInt(input.getAttribute('max'), 10);
    var min = parseInt(input.getAttribute('min'), 10);
    if (!isNaN(max) && quantity > max) quantity = max;
    if (!isNaN(min) && quantity < min) quantity = min;
    return quantity;
  }

  var QTY_INPUTS = '.cart__qty-input, .cart__mini-qty--input, .cart__popup-qty--input';
  var STEP_UP = '.js-qty__adjust--plus, .cart__mini-qty--plus, .cart__popup-qty--plus';
  var STEP_DOWN = '.js-qty__adjust--minus, .cart__mini-qty--minus, .cart__popup-qty--minus';
  var REMOVE = '[data-jm-cart-remove], .remove-from-cart, .cart__popup-remove';

  /* Shopify returns the authoritative quantity in data-rendered-quantity.
     A third-party storefront script can remove the number input's value
     attribute after render; only repair a genuinely blank field so an active
     customer edit is never overwritten. */
  function restoreRenderedQuantities(scope) {
    if (!scope) return;
    var inputs = [];
    if (scope.matches && scope.matches(QTY_INPUTS)) inputs.push(scope);
    if (scope.querySelectorAll) {
      var descendants = scope.querySelectorAll(QTY_INPUTS);
      for (var i = 0; i < descendants.length; i += 1) inputs.push(descendants[i]);
    }

    for (var j = 0; j < inputs.length; j += 1) {
      var input = inputs[j];
      var rendered = parseInt(input.getAttribute('data-rendered-quantity'), 10);
      if (isNaN(rendered) || rendered < 1) continue;
      if (input.value !== '' && input.hasAttribute('value')) continue;
      input.value = String(rendered);
      input.setAttribute('value', String(rendered));
    }
  }

  function setupQuantityIntegrity() {
    restoreRenderedQuantities(document);
    if (!document.body || typeof MutationObserver === 'undefined') return;

    new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') {
          restoreRenderedQuantities(record.target);
          return;
        }
        for (var i = 0; i < record.addedNodes.length; i += 1) {
          if (record.addedNodes[i].nodeType === 1) restoreRenderedQuantities(record.addedNodes[i]);
        }
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value']
    });
  }

  function inputNextTo(button) {
    var wrap = button.parentElement;
    if (!wrap) return null;
    return wrap.querySelector(QTY_INPUTS);
  }

  function focusMarkerFor(control) {
    if (!control) return null;
    var kind = 'remove';
    var input = null;
    if (control.matches(QTY_INPUTS)) {
      kind = 'input';
      input = control;
    } else if (control.matches(STEP_UP)) {
      kind = 'plus';
      input = inputNextTo(control);
    } else if (control.matches(STEP_DOWN)) {
      kind = 'minus';
      input = inputNextTo(control);
    }

    var identity = input || closest(control, '[data-key], [data-id], [data-product-id], [data-line]');
    return {
      surface: closest(control, SELECTORS.section)
        ? 'section'
        : closest(control, SELECTORS.drawer)
          ? 'drawer'
          : closest(control, SELECTORS.popupBody)
            ? 'popup'
            : '',
      kind: kind,
      key: identity
        ? identity.getAttribute('data-key') || identity.getAttribute('data-id') || identity.getAttribute('data-product-id')
        : null,
      line: identity ? identity.getAttribute('data-line') : null
    };
  }

  function matchingInput(surface, marker) {
    var inputs = surface.querySelectorAll(QTY_INPUTS);
    for (var i = 0; i < inputs.length; i += 1) {
      var inputKey = inputs[i].getAttribute('data-key') || inputs[i].getAttribute('data-id');
      if (marker.key && inputKey === marker.key) return inputs[i];
      if (!marker.key && marker.line && inputs[i].getAttribute('data-line') === marker.line) return inputs[i];
    }
    return null;
  }

  function restoreCartFocus(marker) {
    if (!marker) return;
    var active = document.activeElement;
    if (active && active !== document.body && active !== document.documentElement && active.isConnected) return;

    var surface = marker.surface === 'section'
      ? document.querySelector(SELECTORS.section)
      : marker.surface === 'drawer'
        ? document.querySelector(SELECTORS.drawer)
        : document.querySelector(SELECTORS.popupBody);
    if (!surface) return;

    var input = matchingInput(surface, marker);
    var target = input;
    if (input && marker.kind === 'plus') target = input.parentElement.querySelector(STEP_UP);
    if (input && marker.kind === 'minus') target = input.parentElement.querySelector(STEP_DOWN);
    if (target && target.disabled) target = input;

    if (!target) {
      target = marker.surface === 'section'
        ? surface.querySelector(FOCUSABLE)
        : document.querySelector(SELECTORS.drawerClose);
    }
    if (target && !target.disabled) target.focus({ preventScroll: true });
  }

  function onClickCapture(event) {
    var target = event.target;

    var stepper = closest(target, STEP_UP + ', ' + STEP_DOWN);
    if (stepper) {
      var input = inputNextTo(stepper);
      if (!input) return;
      event.preventDefault();
      event.stopPropagation();
      var current = parseInt(input.value, 10);
      if (isNaN(current)) current = 1;
      var step = stepper.matches(STEP_UP) ? 1 : -1;
      var next = clamp(input, current + step);
      if (next === current) return;
      input.value = next;
      changeLine(payloadFor(input, next), focusMarkerFor(stepper));
      return;
    }

    var remove = closest(target, REMOVE);
    if (remove) {
      event.preventDefault();
      event.stopPropagation();
      var holder = remove.matches('[data-product-id], [data-key], [data-line]')
        ? remove
        : remove.querySelector('[data-product-id], [data-key], [data-line]') || remove;
      var key = holder.getAttribute('data-product-id') || holder.getAttribute('data-key');
      var line = holder.getAttribute('data-line');
      if (key) {
        changeLine({ id: key, quantity: 0 }, focusMarkerFor(remove));
      } else if (line) {
        changeLine({ line: parseInt(line, 10), quantity: 0 }, focusMarkerFor(remove));
      }
    }
  }

  function onChangeCapture(event) {
    var input = closest(event.target, QTY_INPUTS);
    if (!input) return;
    event.stopPropagation();
    var quantity = parseInt(input.value, 10);
    if (isNaN(quantity) || quantity < 0) return;
    quantity = clamp(input, quantity);
    input.value = quantity;
    changeLine(payloadFor(input, quantity), focusMarkerFor(input));
  }

  /* ---------------------------------------------------------------- *
   * נגישות מגירת הסל
   * ---------------------------------------------------------------- */

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var lastOpener = null;

  function drawerIsOpen(drawer) {
    return drawer.classList.contains('active');
  }

  function focusableIn(node) {
    var list = node.querySelectorAll(FOCUSABLE);
    var out = [];
    var i;
    for (i = 0; i < list.length; i += 1) {
      if (closest(list[i], '[inert], [aria-hidden="true"]')) continue;
      if (window.getComputedStyle) {
        var style = window.getComputedStyle(list[i]);
        if (style.display === 'none' || style.visibility === 'hidden') continue;
      }
      if (list[i].getClientRects().length || list[i] === document.activeElement) out.push(list[i]);
    }
    return out;
  }

  function closeDrawer() {
    var close = document.querySelector(SELECTORS.drawerClose);
    if (close) close.click();
  }

  function setupDrawer() {
    var drawer = document.querySelector(SELECTORS.drawer);
    if (!drawer) return;

    drawer.setAttribute('role', 'dialog');
    var wasOpen = drawerIsOpen(drawer);

    function syncCartTriggers(open) {
      var triggers = document.querySelectorAll('button.site-header__cart[aria-controls="desktop_cart"]');
      for (var i = 0; i < triggers.length; i += 1) {
        triggers[i].setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }

    function focusWithoutScroll(element) {
      if (!element || !element.isConnected) return;
      try {
        element.focus({ preventScroll: true });
      } catch (error) {
        element.focus();
      }
    }

    function syncDrawerState(moveFocus) {
      var open = drawerIsOpen(drawer);
      drawer.toggleAttribute('inert', !open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      drawer.setAttribute('aria-modal', open ? 'true' : 'false');
      syncCartTriggers(open);

      if (open && !wasOpen) {
        if (!lastOpener && document.activeElement && !drawer.contains(document.activeElement)) {
          lastOpener = document.activeElement;
        }
        if (moveFocus) {
          window.setTimeout(function () {
            focusWithoutScroll(drawer.querySelector(SELECTORS.drawerClose) || drawer);
          }, 0);
        }
      } else if (!open && wasOpen) {
        var opener = lastOpener;
        lastOpener = null;
        window.setTimeout(function () { focusWithoutScroll(opener); }, 0);
      }
      wasOpen = open;
    }

    document.addEventListener(
      'click',
      function (event) {
        var opener = closest(
          event.target,
          '.header-cart, .site-header__cart, .product-form__cart-submit, .btnAddToCart, [data-btn-addToCart], .btn-bundle-add-to-cart, .js_add_all_to_cart'
        );
        if (opener && !drawer.contains(opener)) {
          lastOpener = opener;
        }
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      if (!drawerIsOpen(drawer)) return;

      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (event.key !== 'Tab') return;

      var items = focusableIn(drawer);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];

      if (!drawer.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
        return;
      }
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    new MutationObserver(function () { syncDrawerState(true); })
      .observe(drawer, { attributes: true, attributeFilter: ['class'] });
    syncDrawerState(false);
  }

  /* ---------------------------------------------------------------- *
   * חלון אישור הוספה לסל
   *
   * Magnific Popup של הספק מייצר את המעטפת בזמן ריצה, אך _setFocus שלו
   * ריק וכפתור הסגירה שלו הוא i. משאירים את מחזור הפתיחה/סגירה של הספק
   * ומוסיפים מעליו חוזה מודאל מלא: שם, כפתור, פוקוס, Escape ו-Tab.
   * ---------------------------------------------------------------- */

  var activeCartPopup = null;
  var cartPopupOpener = null;
  var pendingCartPopupOpener = null;
  var popupBackground = [];
  var cartPopupFocusFrame = null;
  var cartPopupFocusFrameType = '';
  var cartPopupFocusStartedAt = 0;
  var cartPopupClosing = false;
  var cartPopupVendorBound = false;

  function setPopupBackgroundInert(popup) {
    restorePopupBackground();
    if (!document.body) return;
    var wrap = closest(popup, '.nov-wrap');
    var children = document.body.children;
    for (var i = 0; i < children.length; i += 1) {
      var node = children[i];
      if (node === wrap || node.classList.contains('nov-bg')) continue;
      var hadInert = node.hasAttribute('inert');
      popupBackground.push({ node: node, hadInert: hadInert });
      if (!hadInert) node.setAttribute('inert', '');
    }
  }

  function restorePopupBackground() {
    for (var i = 0; i < popupBackground.length; i += 1) {
      var entry = popupBackground[i];
      if (entry.node && entry.node.isConnected && !entry.hadInert) entry.node.removeAttribute('inert');
    }
    popupBackground = [];
  }

  function popupCloseButton(popup) {
    return popup ? popup.querySelector('.jm-cart-popup-close, .nov-close') : null;
  }

  function cancelCartPopupFocusGuard() {
    if (cartPopupFocusFrame === null) return;
    if (cartPopupFocusFrameType === 'raf' && window.cancelAnimationFrame) {
      window.cancelAnimationFrame(cartPopupFocusFrame);
    } else {
      window.clearTimeout(cartPopupFocusFrame);
    }
    cartPopupFocusFrame = null;
    cartPopupFocusFrameType = '';
  }

  function focusCartPopup() {
    var popup = activeCartPopup;
    if (!popup || !popup.isConnected || popup.contains(document.activeElement)) return;
    var close = popupCloseButton(popup);
    var candidates = close ? [close] : [];
    var controls = focusableIn(popup);
    for (var i = 0; i < controls.length; i += 1) {
      if (controls[i] !== close) candidates.push(controls[i]);
    }
    candidates.push(popup);

    for (var j = 0; j < candidates.length; j += 1) {
      candidates[j].focus({ preventScroll: true });
      if (popup.contains(document.activeElement)) return;
    }
  }

  function installCartPopupVendorFocusBridge() {
    var instance = window.jQuery && window.jQuery.magnificPopup
      ? window.jQuery.magnificPopup.instance
      : null;
    if (!instance) return;
    if (!instance.__jmCartPopupFocusBridgeInstalled) {
      var originalSetFocus = instance._setFocus;
      instance.__jmCartPopupFocusBridgeInstalled = true;
      instance._setFocus = function () {
        if (activeCartPopup && activeCartPopup.isConnected) {
          focusCartPopup();
          return;
        }
        if (typeof originalSetFocus === 'function') return originalSetFocus.apply(this, arguments);
      };
    }
    if (instance.st) instance.st.focus = '.jm-cart-popup-close';
  }

  function cartPopupIsReady(popup) {
    if (!popup || !popup.getClientRects().length) return false;
    if (!window.getComputedStyle) return true;
    var style = window.getComputedStyle(popup);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function queueCartPopupFocusFrame(callback) {
    if (window.requestAnimationFrame) {
      cartPopupFocusFrameType = 'raf';
      return window.requestAnimationFrame(callback);
    }
    cartPopupFocusFrameType = 'timeout';
    return window.setTimeout(callback, 16);
  }

  function startCartPopupFocusGuard() {
    cancelCartPopupFocusGuard();
    cartPopupFocusStartedAt = Date.now();

    function guardFrame() {
      cartPopupFocusFrame = null;
      cartPopupFocusFrameType = '';
      if (!activeCartPopup || !activeCartPopup.isConnected || cartPopupClosing) return;

      makePopupCloseAccessible(activeCartPopup);
      installCartPopupVendorFocusBridge();
      if (cartPopupIsReady(activeCartPopup)) focusCartPopup();

      if (Date.now() - cartPopupFocusStartedAt < 3000) {
        cartPopupFocusFrame = queueCartPopupFocusFrame(guardFrame);
      }
    }

    guardFrame();
  }

  function makePopupCloseAccessible(popup) {
    var original = popup.querySelector('.nov-close');
    var labelSource = popup.querySelector('[data-jm-cart-popup-content]');
    var label = labelSource ? labelSource.getAttribute('data-close-label') : '';
    if (!label) label = 'סגירה';

    if (original && original.tagName.toLowerCase() === 'button') {
      original.type = 'button';
      original.classList.add('jm-cart-popup-close');
      original.setAttribute('aria-label', label);
      original.removeAttribute('title');
      return original;
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'nov-close close-icon jm-cart-popup-close';
    button.setAttribute('aria-label', label);
    if (original) original.replaceWith(button);
    else popup.insertBefore(button, popup.firstChild);
    return button;
  }

  function closeCartPopup() {
    var close = popupCloseButton(activeCartPopup);
    if (close) {
      close.click();
      return;
    }
    if (window.jQuery && window.jQuery.magnificPopup) window.jQuery.magnificPopup.close();
  }

  function enhanceCartPopup(popup) {
    if (!popup || popup === activeCartPopup) return;
    activeCartPopup = popup;
    cartPopupOpener = pendingCartPopupOpener ||
      (document.activeElement && document.activeElement !== document.body ? document.activeElement : null);
    pendingCartPopupOpener = null;

    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-labelledby', 'CartPopupTitle');
    popup.setAttribute('aria-hidden', 'false');
    popup.setAttribute('tabindex', '-1');
    popup.setAttribute('data-jm-cart-popup-dialog', '');

    makePopupCloseAccessible(popup);
    setPopupBackgroundInert(popup);
    installCartPopupVendorFocusBridge();
    startCartPopupFocusGuard();
  }

  function releaseCartPopup() {
    var opener = cartPopupOpener;
    cancelCartPopupFocusGuard();
    activeCartPopup = null;
    cartPopupOpener = null;
    cartPopupClosing = false;
    restorePopupBackground();
    if (document.body) document.body.classList.remove('cart_popup_opened');
    window.setTimeout(function () {
      if (opener && opener.isConnected && !opener.disabled) opener.focus({ preventScroll: true });
    }, 0);
  }

  function bindCartPopupVendorEvents() {
    if (cartPopupVendorBound || !window.jQuery) return;
    cartPopupVendorBound = true;
    installCartPopupVendorFocusBridge();
    window.jQuery(document)
      .on('novOpen.jmCartPopup', function () {
        var popup = document.querySelector(SELECTORS.popupDialog);
        if (popup) enhanceCartPopup(popup);
      })
      .on('novBeforeClose.jmCartPopup', function () {
        if (!activeCartPopup) return;
        cartPopupClosing = true;
        cancelCartPopupFocusGuard();
      })
      .on('novAfterClose.jmCartPopup', function () {
        if (!cartPopupClosing) return;
        releaseCartPopup();
      });
  }

  function setupCartPopup() {
    if (!document.body) return;
    bindCartPopupVendorEvents();
    window.addEventListener('load', bindCartPopupVendorEvents, { once: true });

    document.addEventListener(
      'click',
      function (event) {
        var opener = closest(
          event.target,
          '.product-form__cart-submit, .btnAddToCart, [data-btn-addToCart], .js_add_all_to_cart'
        );
        if (opener && !closest(opener, SELECTORS.popupDialog)) pendingCartPopupOpener = opener;
      },
      true
    );

    document.addEventListener(
      'keydown',
      function (event) {
        var popup = activeCartPopup;
        if (!popup || !popup.isConnected) return;

        if (event.key === 'Escape' || event.key === 'Esc') {
          event.preventDefault();
          event.stopPropagation();
          closeCartPopup();
          return;
        }

        if (event.key !== 'Tab') return;
        var items = focusableIn(popup);
        if (!items.length) {
          event.preventDefault();
          popup.focus();
          return;
        }
        var first = items[0];
        var last = items[items.length - 1];
        if (!popup.contains(document.activeElement)) {
          event.preventDefault();
          first.focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      },
      true
    );

    document.addEventListener(
      'focusin',
      function (event) {
        if (!activeCartPopup || !activeCartPopup.isConnected || activeCartPopup.contains(event.target)) return;
        var target = popupCloseButton(activeCartPopup) || activeCartPopup;
        target.focus({ preventScroll: true });
      },
      true
    );

    function syncPopup() {
      var popup = document.querySelector(SELECTORS.popupDialog);
      if (popup) enhanceCartPopup(popup);
      else if (activeCartPopup) releaseCartPopup();
    }

    new MutationObserver(syncPopup).observe(document.body, { childList: true, subtree: true });
    syncPopup();
  }

  /* ---------------------------------------------------------------- *
   * לוחות ההערה וקוד ההנחה
   *
   * קוד הספק ממשיך להפעיל את הלוחות לפי המחלקות ו-data-label. כאן
   * מסנכרנים את המצב הנגיש, שומרים את הערת ההזמנה מול Shopify ומחזירים
   * פוקוס לפותח רק אחרי שמירה מוצלחת או ביטול מפורש.
   * ---------------------------------------------------------------- */

  function setupCartExtensions() {
    var drawer = document.querySelector(SELECTORS.drawer);
    if (!drawer) return;
    var lastExtensionOpeners = {};
    var noteSaving = false;

    function focusExtensionOpener(label) {
      var returnTarget = lastExtensionOpeners[label] ||
        drawer.querySelector('.extend--label__item[data-label="' + label + '"]');
      if (!returnTarget || !returnTarget.isConnected || returnTarget.disabled) return;
      window.setTimeout(function () {
        try {
          returnTarget.focus({ preventScroll: true });
        } catch (error) {
          returnTarget.focus();
        }
      }, 0);
    }

    function closeExtension(label, restoreFocus) {
      var panels = drawer.querySelectorAll('.cart_extend[data-content]');
      var openers = drawer.querySelectorAll('.extend--label__item[data-label]');
      var i;
      for (i = 0; i < panels.length; i += 1) {
        panels[i].classList.remove('act');
        panels[i].setAttribute('aria-hidden', 'true');
      }
      for (i = 0; i < openers.length; i += 1) {
        openers[i].classList.remove('act');
        openers[i].setAttribute('aria-expanded', 'false');
        var title = openers[i].getAttribute('data-title');
        if (title) openers[i].setAttribute('data-original-title', title);
      }
      var labels = drawer.querySelectorAll('.cart_extend--label');
      for (i = 0; i < labels.length; i += 1) labels[i].classList.remove('act');
      drawer.classList.remove('open-extend');
      if (restoreFocus) focusExtensionOpener(label);
    }

    function feedbackFor(panel) {
      var feedback = panel.querySelector('[data-jm-cart-note-status]');
      if (feedback) return feedback;
      feedback = document.createElement('p');
      feedback.id = 'CartDrawerNoteStatus';
      feedback.className = 'cart_extend--feedback';
      feedback.setAttribute('data-jm-cart-note-status', '');
      feedback.setAttribute('role', 'status');
      feedback.setAttribute('aria-live', 'polite');
      feedback.setAttribute('aria-atomic', 'true');
      feedback.hidden = true;
      var content = panel.querySelector('.cart_extend-content') || panel;
      content.appendChild(feedback);
      var note = panel.querySelector('[name="note"]');
      if (note) {
        var describedBy = note.getAttribute('aria-describedby') || '';
        if (describedBy.split(/\s+/).indexOf(feedback.id) === -1) {
          note.setAttribute('aria-describedby', (describedBy + ' ' + feedback.id).trim());
        }
      }
      return feedback;
    }

    function setNoteFeedback(panel, message, failed) {
      var feedback = feedbackFor(panel);
      feedback.hidden = !message;
      feedback.classList.toggle('is-error', Boolean(failed));
      feedback.textContent = message || '';
    }

    function finishNoteRequest(action, panel) {
      noteSaving = false;
      action.disabled = false;
      action.removeAttribute('aria-busy');
      action.classList.remove('loading');
      panel.removeAttribute('aria-busy');
    }

    function saveCartNote(action, panel) {
      if (noteSaving) return;
      var note = panel.querySelector('[name="note"]');
      if (!note) {
        setNoteFeedback(panel, 'לא ניתן לשמור את ההערה כרגע. נסו שוב.', true);
        return;
      }

      noteSaving = true;
      note.removeAttribute('aria-invalid');
      setNoteFeedback(panel, '', false);
      action.disabled = true;
      action.setAttribute('aria-busy', 'true');
      action.classList.add('loading');
      panel.setAttribute('aria-busy', 'true');

      fetch(rootPath() + '/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ note: note.value })
      })
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.json();
        })
        .then(
          function (cart) {
            var message = 'ההערה נשמרה.';
            announce(message, false);
            if (cart && typeof cart.item_count === 'number') syncHeader(cart.item_count);
            finishNoteRequest(action, panel);
            closeExtension('note', true);
          },
          function () {
            var message = 'לא הצלחנו לשמור את ההערה. נסו שוב.';
            finishNoteRequest(action, panel);
            note.setAttribute('aria-invalid', 'true');
            setNoteFeedback(panel, message, true);
            if (panel.classList.contains('act')) note.focus();
          }
        );
    }

    function syncExtensionState() {
      var panels = drawer.querySelectorAll('.cart_extend[data-content]');
      var i;
      for (i = 0; i < panels.length; i += 1) {
        panels[i].setAttribute('aria-hidden', panels[i].classList.contains('act') ? 'false' : 'true');
      }

      var openers = drawer.querySelectorAll('.extend--label__item[data-label]');
      for (i = 0; i < openers.length; i += 1) {
        openers[i].setAttribute('aria-expanded', openers[i].classList.contains('act') ? 'true' : 'false');
      }
    }

    document.addEventListener(
      'click',
      function (event) {
        var opener = closest(event.target, '.extend--label__item[data-label]');
        if (opener && drawer.contains(opener)) {
          var label = opener.getAttribute('data-label');
          lastExtensionOpeners[label] = opener;
          window.setTimeout(function () {
            syncExtensionState();
            if (!opener.classList.contains('act')) return;
            var panel = drawer.querySelector('.cart_extend[data-content="' + label + '"]');
            var field = panel && panel.querySelector('textarea, input, button');
            if (field) field.focus();
          }, 0);
          return;
        }

        var action = closest(event.target, '.cart_extend--btn');
        if (action && drawer.contains(action)) {
          var panel = closest(action, '.cart_extend[data-content]');
          var panelLabel = panel ? panel.getAttribute('data-content') : '';
          var isNoteSave = panelLabel === 'note' && !action.classList.contains('cancel');
          if (isNoteSave) {
            event.preventDefault();
            event.stopImmediatePropagation();
            saveCartNote(action, panel);
            return;
          }
          window.setTimeout(function () {
            syncExtensionState();
            focusExtensionOpener(panelLabel);
          }, 0);
        }
      },
      true
    );

    document.addEventListener(
      'input',
      function (event) {
        var note = closest(event.target, '.cart_extend[data-content="note"] [name="note"]');
        if (!note || !drawer.contains(note)) return;
        note.removeAttribute('aria-invalid');
        var panel = closest(note, '.cart_extend[data-content="note"]');
        if (panel) setNoteFeedback(panel, '', false);
      },
      true
    );

    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Escape' && event.key !== 'Esc') return;
        if (!drawerIsOpen(drawer)) return;
        var panel = drawer.querySelector('.cart_extend[data-content].act');
        if (!panel) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        closeExtension(panel.getAttribute('data-content') || '', true);
      },
      true
    );

    new MutationObserver(syncExtensionState).observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    syncExtensionState();
  }

  /* ---------------------------------------------------------------- *
   * שמירה על גרסת השרת במגירה
   *
   * js-nuranium כותב ל-#cart-info פעמיים בטעינת עמוד ושוב אחרי כל
   * שינוי, לפעמים מ-Liquid ולפעמים ממחרוזות שהוא בונה בעצמו. במקום
   * לנחש מתי הוא סיים, מסמנים את פלט השרת ב-data-jm-drawer ומחזירים
   * אותו בכל פעם שהסימן נעלם. בלי טיימר ובלי מרוץ.
   * ---------------------------------------------------------------- */

  /*
   * The drawer body is loaded when it is first needed, not on every page view.
   *
   * Until now every page load made four to six cart requests before anyone touched the cart:
   * js-nuranium's initMiniCart (/cart?view=extend, then /cart.js, then a drawer built from
   * strings) and this file's /cart?view=json, twice, once for the placeholder and once more
   * after initMiniCart overwrote it. The header count is rendered by Liquid, so none of that
   * was needed to draw the page. initMiniCart no longer runs at load (js-nuranium.js init), and
   * the drawer is fetched when it opens, or a moment earlier, when a finger or pointer reaches
   * the cart button. Adding to the cart still renders the drawer as before.
   */
  function watchDrawerBody() {
    var body = document.querySelector(SELECTORS.drawerBody);
    if (!body) return;
    var drawer = document.querySelector(SELECTORS.drawer);

    var pending = false;
    var wanted = false;

    function ensureServerMarkup() {
      if (pending) return;
      if (body.querySelector('[data-jm-drawer]')) return;
      pending = true;
      refreshDrawer().catch(function () {
        announce(strings.update_failed || '', true);
      }).then(function () {
        pending = false;
      });
    }

    function want() {
      if (!wanted) {
        wanted = true;
        // The note and coupon panels of the drawer (/cart?view=extend), which initMiniCart used to
        // insert on every page view.
        if (!document.querySelector('.form-cart__extent') && window.nov && typeof window.nov.initCartExtend === 'function') {
          window.nov.initCartExtend();
        }
      }
      ensureServerMarkup();
    }

    // Whatever writes into the drawer later (the vendor's add-to-cart, a removal) is replaced by
    // the server markup, as before.
    new MutationObserver(ensureServerMarkup).observe(body, { childList: true, subtree: false });
    if (drawer) {
      new MutationObserver(function () {
        if (drawerIsOpen(drawer)) want();
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      if (drawerIsOpen(drawer)) want();
    }
    ['pointerover', 'touchstart', 'focusin'].forEach(function (type) {
      document.addEventListener(type, function (event) {
        if (!wanted && closest(event.target, '.header-cart, .site-header__cart')) want();
      }, { passive: true, capture: true });
    });
  }

  /* ---------------------------------------------------------------- *
   * הכפתור שליד שדה הקופון
   *
   * מה הוא עושה בפועל, ומה הוא לא: שופיפיי מחילה קוד הנחה בקופה, לא
   * בסל, ואין ב-Basic נקודת קצה שמאמתת קוד מול הסל. לכן הכפתור לא
   * אומר "הקוד תקף" — הוא שומר את הקוד (בתוך ‎name="discount"‎ של טופס
   * הסל, שעובר לקופה, ובאותה עוגייה ‎discountCode‎ שהלוח הישן כתב,
   * כדי שהוא ישרוד גם טעינת עמוד) ומאשר בדיוק את זה.
   * ---------------------------------------------------------------- */

  var COUPON_COOKIE = 'discountCode';

  function writeCouponCookie(value) {
    var expires = new Date(Date.now() + 30 * 864e5).toUTCString();
    try {
      document.cookie =
        COUPON_COOKIE + '=' + encodeURIComponent(value) + ';expires=' + expires + ';path=/;SameSite=Lax';
    } catch (error) {
      /* עוגיות חסומות — הערך עדיין נמצא בשדה ועובר לקופה עם הטופס */
    }
  }

  function readCouponCookie() {
    var match = (' ' + document.cookie).match(/[; ]discountCode=([^;]*)/);
    if (!match) return '';
    try {
      return decodeURIComponent(match[1]);
    } catch (error) {
      return match[1];
    }
  }

  function couponMessage(scope, key) {
    var msg = scope.querySelector('[data-jm-coupon-msg]');
    if (!msg) return;
    msg.textContent = strings[key] || '';
    if (key === 'coupon_empty') {
      msg.setAttribute('data-state', 'error');
    } else {
      msg.removeAttribute('data-state');
    }
  }

  function applyCoupon(button) {
    var scope = closest(button, '[data-jm-coupon]') || button.parentElement;
    if (!scope) return;
    var input = scope.querySelector('[data-jm-cart-keep]');
    if (!input) return;
    var value = (input.value || '').trim();
    input.value = value;
    if (!value) {
      couponMessage(scope, 'coupon_empty');
      try {
        input.focus({ preventScroll: true });
      } catch (error) {
        input.focus();
      }
      return;
    }
    writeCouponCookie(value);
    couponMessage(scope, 'coupon_saved');
  }

  function setupCoupon() {
    document.addEventListener('click', function (event) {
      var button = closest(event.target, '[data-jm-coupon-apply]');
      if (!button) return;
      event.preventDefault();
      applyCoupon(button);
    });

    /*
     * קוד שנשמר בביקור קודם חוזר אל השדה. השדה נולד מחדש בכל רינדור,
     * ולכן זה רץ גם על גוף מגירה חדש ולא פעם אחת בטעינה.
     */
    function seedFromCookie() {
      var saved = readCouponCookie();
      if (!saved) return;
      var fields = document.querySelectorAll('[data-jm-cart-keep]');
      for (var i = 0; i < fields.length; i += 1) {
        if (fields[i].value) continue;
        fields[i].value = saved;
        var scope = closest(fields[i], '[data-jm-coupon]');
        if (scope) scope.setAttribute('open', '');
      }
    }

    seedFromCookie();
    var body = document.querySelector(SELECTORS.drawerBody);
    if (body) new MutationObserver(seedFromCookie).observe(body, { childList: true, subtree: false });
  }

  /* ---------------------------------------------------------------- *
   * הוספה מהירה מרצועת ההמלצות
   * ---------------------------------------------------------------- */

  /*
   * הכפתור קיים רק על מוצר עם ווריאנט זמין יחיד (ראו jm-cart-suggest),
   * ולכן אין כאן שאלה איזה ווריאנט להוסיף. מוצר עם צבעים או מידות
   * מקבל קישור לעמוד המוצר במקום כפתור.
   *
   * אחרי ההוספה נמשך ‎/cart.js‎ כדי לקבל את המונה מהשרת ולא לספור
   * בדפדפן, ואז ‎refreshAll‎ — אותו מסלול שכל שינוי כמות עובר בו,
   * כך שהמגירה, העמוד והחלונית נשארים על אותו מקור אמת.
   *
   * הכפתור עצמו נמחק מה-DOM ברענון, ולכן שחרור הנעילה נעשה רק אם
   * הוא עדיין מחובר למסמך.
   */
  function quickAdd(button) {
    var id = button.getAttribute('data-jm-quick-add');
    if (!id || button.disabled) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    announce(strings.updating || '');

    fetch(rootPath() + '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return fetch(rootPath() + '/cart.js', { credentials: 'same-origin' });
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then(function (cart) {
        return refreshAll(cart.item_count).then(function () {
          announce(strings.added || strings.updated || '');
        });
      })
      .catch(function () {
        announce(strings.update_failed || '', true);
      })
      .then(function () {
        if (!button.isConnected) return;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }

  function setupQuickAdd() {
    document.addEventListener('click', function (event) {
      var button = closest(event.target, '[data-jm-quick-add]');
      if (!button) return;
      event.preventDefault();
      quickAdd(button);
    });
  }

  /* ---------------------------------------------------------------- *
   * אתחול
   * ---------------------------------------------------------------- */

  function init() {
    readStrings();
    setupHeaderCountLabel();
    setupQuantityIntegrity();
    document.addEventListener('click', onClickCapture, true);
    document.addEventListener('change', onChangeCapture, true);
    /* js-nuranium מאזין גם ל-keyup על שדה הכמות ושולח שינוי על כל הקשה.
       עוצרים את ההתפשטות כדי שהשינוי יישלח פעם אחת, ב-change. */
    document.addEventListener(
      'keyup',
      function (event) {
        if (closest(event.target, QTY_INPUTS)) event.stopPropagation();
      },
      true
    );
    setupDrawer();
    setupCartPopup();
    setupCartExtensions();
    setupCoupon();
    setupQuickAdd();

    watchDrawerBody();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
